export default __webpack_public_path__ + "c312266dd89f8d61693afb715ddd3e56.svg";